import { AddressValidationResult } from '@nkr/enums/address-validation-result';

export interface IUsPsAddressResponse {
    address1: string,
    address2: string,
    city: string,
    state: string,
    stateName: string,
    zip5: string,
    zip4: string,
    result: AddressValidationResult,
    resultText: string
}